import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const MobileTrigger = styled.button`
  display: none;

  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    width: 100%;
    padding: ${space[3]} ${space[4]};
    background: ${colors.lightGrey};
    border: 1px solid ${colors.borderGrey};
    border-radius: 28px;
    cursor: pointer;
    font-family: ${fonts.body};
    color: ${colors.fontPrimary};
  }
`;

export const MobileTriggerTitle = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  text-align: center;
  overflow-wrap: break-word;
  max-width: 100%;
`;

export const MobileTriggerSubtitle = styled.span`
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
  text-align: center;
  overflow-wrap: break-word;
  max-width: 100%;
`;

export const MobileModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${colors.white};
  z-index: ${layout.zIndexModal};
  display: flex;
  flex-direction: column;
`;

export const MobileModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space[2]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.fontPrimary};
  border-radius: ${layout.borderRadiusFull};
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;

export const MobileModalHeader = styled.header`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${space[4]} ${space[4]} ${space[4]};
  border-bottom: 1px solid ${colors.borderGreyLighter};
`;

export const MobileModalTitle = styled.h2`
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const MobileModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${space[4]};
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const MobileModalFooter = styled.div`
  flex-shrink: 0;
  padding: ${space[4]};
  border-top: 1px solid ${colors.borderGrey};
`;

export const MobileSearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  background: ${colors.primary};
  color: ${colors.white};
  border: none;
  border-radius: ${layout.borderRadiusFull};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`;

export const MobileSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
  padding: ${space[4]};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadiusLg};
  background: ${colors.white};
`;

export const MobileSectionValue = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const MobileCategoryWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const MobileCategoryDropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${space[3]} ${space[4]};
  background: ${colors.lighterGrey};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
`;

export const MobileCategoryDropdownList = styled.div`
  position: absolute;
  top: calc(100% + ${space[2]});
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  background: ${colors.white};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const MobileEditButton = styled.button`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: ${space[2]} ${space[4]};
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadiusFull};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const MobileCalendarWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${space[2]};
  display: flex;
  justify-content: center;

  > div {
    width: 100%;
    max-width: none;
    border: none;
    box-shadow: none;
    padding: 0;

    @media (min-width: 660px) {
      width: 100%;
    }
  }
`;

export const MobileBackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space[2]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.fontPrimary};
  border-radius: ${layout.borderRadiusFull};
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;

export const MobileSubModalHeader = styled.header`
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  gap: ${space[2]};
  padding: ${space[4]} ${space[4]} ${space[4]};
  border-bottom: 1px solid ${colors.borderGreyLighter};

  > :first-child {
    justify-self: start;
  }

  > :last-child {
    justify-self: end;
  }
`;

export const GuestModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${space[4]};
  display: flex;
  flex-direction: column;
  align-items: center;

  > div {
    width: 100%;
    max-width: 480px;
    border: none;
    box-shadow: none;
    padding: 0;
  }
`;
